// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3Vqt6","section":"App_section__16snZ"};